import { useState, useEffect } from 'react';
import { Container, Grid, Typography, Box, TextField, Accordion, AccordionSummary, AccordionActions, Button, Dialog, DialogActions, DialogTitle } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import SearchIcon from '@mui/icons-material/Search'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import AddIcon from '@mui/icons-material/Add';
import { useAuth } from '../context/AuthContext';
import globals from '../globals';

const combineName = (instructor) => {
    return instructor.first_name + ' ' + instructor.last_name
}

const InstructorPage = () => {

    const { token, login } = useAuth()

    const [filterName, setFilterName] = useState('');
    const [instructorsState, setInstructorState] = useState([]);
    const [openDialog, setOpenDialog] = useState(null); // Track which instructor's dialog is open (instructorId or null)
    const [dialogType, setDialogType] = useState('');
    const [dialogAction, setDialogAction] = useState();
    const [loadingStates, setLoadingStates] = useState({}); // Track loading by instructorId and button type

    useEffect(() => {

        fetch(globals.apiUrl + '/admin/instructors', {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        })
            .then(response => response.json())
            .then(data => {
                setInstructorState(data)
            })
            .catch(error => {
                console.error('Error:', error);
            })
    }, []);

    const handleClickOpenDialog = (instructorId, type, action) => {
        setDialogType(type);
        setDialogAction(() => action);
        setOpenDialog(instructorId);
    };

    const handleCloseDialog = (callAction) => {
        if (callAction && dialogAction) {
            dialogAction();
        }
        setOpenDialog(null);
        setDialogType('');
    };

    const impersonateInstructor = (id) => {
        setLoadingStates(prev => ({ ...prev, [`${id}-impersonate`]: true }));

        fetch(globals.apiUrl + `/admin/users/${id}/impersonate`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                }
            })
            .then(async response => {
                const data = await response.json();
                if (!response.ok) {
                    throw new Error(typeof data.detail === 'string' ? data.detail : 'Неуспешно влизане като потребител');
                }
                login(data);
            })
            .catch(error => {
                console.error('Error:', error);
                window.alert(error.message);
                setLoadingStates(prev => ({ ...prev, [`${id}-impersonate`]: false }));
            })
    }

    const deleteInstructor = (id) => {
        setLoadingStates(prev => ({ ...prev, [`${id}-delete`]: true }));

        fetch(globals.apiUrl + `/admin/users/${id}/delete`,
            {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                }
            })
            .then(response => response.json())
            .then(data => {
                setInstructorState(instructorsState.filter(instructor => instructor.id != id))
                setLoadingStates(prev => ({ ...prev, [`${id}-delete`]: false }));
            })
            .catch(error => {
                console.error('Error:', error);
                setLoadingStates(prev => ({ ...prev, [`${id}-delete`]: false }));
            })
    }

    const filterFunction = () => {
        return instructorsState.filter(instructor => combineName(instructor).toLocaleLowerCase().includes(filterName.toLocaleLowerCase()) || instructor.email.toLocaleLowerCase().includes(filterName.toLocaleLowerCase()))
    }

    return (
        <Container>
            <Grid container>
                <Grid item sm={6}>
                    <Typography sx={{ fontWeight: 'bold', fontSize: 25, textTransform: 'uppercase' }}>
                        Учители
                    </Typography>
                </Grid>
                <Grid item sm={6}>
                    <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
                        <SearchIcon fontSize='large' sx={{ color: 'action.active', mr: 1, my: 1 }} />
                        <TextField fullWidth placeholder="Търсене" onChange={(event) => setFilterName(event.target.value)} />
                    </Box>
                </Grid>
            </Grid>

            <Grid container sx={{ mt: 2 }} spacing={1}>
                {filterFunction().map(instructor => (
                    <Grid item sm={12} key={instructor.id}>
                        <Accordion fullWidth>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                <Typography component="span"> <strong>{combineName(instructor)}</strong> | {instructor.email}</Typography>
                            </AccordionSummary>
                            <AccordionActions>
                                <LoadingButton loading={loadingStates[`${instructor.id}-impersonate`] || false} color='primary' variant="contained" onClick={() => handleClickOpenDialog(instructor.id, 'impersonate', () => impersonateInstructor(instructor.id))}>Влез като</LoadingButton>
                                <Button variant='contained' color='secondary' href={`/admin-edit-profile/${instructor.id}`}>Редактирай</Button>
                                <LoadingButton loading={loadingStates[`${instructor.id}-delete`] || false} onClick={() => handleClickOpenDialog(instructor.id, 'delete', () => deleteInstructor(instructor.id))} variant='contained' color='error'>Изтрий</LoadingButton>
                                <Dialog
                                    open={openDialog === instructor.id}
                                    onClose={() => handleCloseDialog(false)}
                                >
                                    <DialogTitle id="alert-dialog-title">
                                        {dialogType == "impersonate" ? "Искате ли да влезете като този учител?" : "Искате ли да изтриете този учител?"}
                                    </DialogTitle>
                                    <DialogActions>
                                        <Button onClick={() => handleCloseDialog(true)}>Да</Button>
                                        <Button onClick={() => handleCloseDialog(false)} autoFocus>
                                            Не
                                        </Button>
                                    </DialogActions>
                                </Dialog>
                            </AccordionActions>
                        </Accordion>
                    </Grid>
                ))}
            </Grid>
        </Container>
    );
}

export default InstructorPage
